import Action from "./Action";
import Shape from "../Main/Shape.js";
import {Serialization} from "../Main/Serializer";

export default class ShapeAddAction implements Action {

    constructor(readonly shape: Shape, readonly position: number) {

    }

    public apply() {
        this.shape.shapeCollection.attachShape(this.shape, this.position);
        this.shape.shapeCollection.focusShape(this.shape);
    }

    public revert() {
        this.shape.shapeCollection.unfocus();
        this.shape.shapeCollection.detachShape(this.shape);

        this.shape.shapeCollection.checkCloseShapesPanel();
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            position: this.position,
        };
    }
}
